import LocationHelper from '../../helpers/location_helper';
import moment from 'moment/moment';
import cookie from 'cookie';

class QAHiddenDriver {
  // Because React doesnt play well with others, we must first become React
  static setInputValue(element, value) {
    element.focus();
    Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set.call(element, value);
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(
      new Event('focusout', {
        bubbles: true,
      })
    );
  }

  static setSelectValue(element, value) {
    element.focus();

    // Set the value property directly for Select elements
    const selectDescriptor = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value');
    selectDescriptor.set.call(element, value);

    // Optionally, you can set the selected property on the options directly
    Array.from(element.options).forEach((option) => {
      option.selected = option.value === value;
    });

    // Trigger the change event for React to pick up the change
    element.dispatchEvent(new Event('change', { bubbles: true }));
    element.dispatchEvent(new Event('focusout', { bubbles: true }));
  }

  static getPreferredContactInfo() {
    const expiresDate = moment()
      .add(Number(12 * 30 * 24 * 60 * 60 * 1000), 'seconds')
      .toDate()
      .toUTCString();

    document.cookie = `qaPreferredEmail=${prompt(
      'Please enter your preferred Email, add +NOW for entropy'
    )};expires=${expiresDate};path=/;domain=${LocationHelper.getCookieHost()}`;

    document.cookie = `qaPreferredPhone=${prompt(
      'Please enter your preferred Phone'
    )};expires=${expiresDate};path=/;domain=${LocationHelper.getCookieHost()}`;
  }

  static getPreferredEmail(app) {
    let email = cookie.parse(document.cookie)['qaPreferredEmail'] || null;
    if (app === 'coapp' && email) {
      return email.replace('+', '+coapp');
    }
    return email;
  }

  static getPreferredPhone() {
    return cookie.parse(document.cookie)['qaPreferredPhone'] || null;
  }

  static getElementByName(name) {
    return name && document.getElementsByName(name) && document.getElementsByName(name)[0];
  }

  static getElementByClass(clazz) {
    return clazz && document.getElementsByClassName(clazz) && document.getElementsByClassName(clazz)[0];
  }

  static getElementById(id) {
    return id && document.getElementById(id);
  }

  static async waitForElement(fnc, tries = 120) {
    console.log(`Attempting to find element X=${tries} times: ${fnc.id || fnc.name || fnc.class}`);

    for (let i = 0; i < tries; i++) {
      if (
        QAHiddenDriver.getElementById(fnc.id) ||
        QAHiddenDriver.getElementByName(fnc.name) ||
        QAHiddenDriver.getElementByClass(fnc.class)
      ) {
        console.log(`Found element: ${fnc.id || fnc.name || fnc.class}`);
        return Promise.resolve();
      }

      console.log(`Could not find element: ${fnc.id || fnc.name || fnc.class}. Retry ${i + 1}/${tries}`);
      await new Promise((resolve) => setTimeout(resolve, 750)); // Wait for 750ms before the next retry
    }

    throw new Error(`Element not found after ${tries} attempts: ${fnc.id || fnc.name || fnc.class}`);
  }

  static async sleep(timeout) {
    return new Promise((resolve) => setTimeout(resolve, timeout));
  }

  static modifierMap = {
    includeNotifyApp: 'Notify',
    includeStackApp: 'Stack',
    includeDupeInfo: 'vAlIdAtE',
    includeEnsemble: 'RealEVCall',
    includeRealInverter: 'RealInverterCall',
    includeRealAnalysis: 'AnalyzeReal',
  };
  static tryAll({ input, mockModifiers }) {
    let emailEnv = LocationHelper.getEnvByDomain();
    emailEnv = 'prod' === emailEnv ? 'default' : emailEnv;

    input.lastNameOverrides = Object.keys(mockModifiers)
      .filter((k) => mockModifiers[k])
      .map((k) => this.modifierMap[k])
      .join('');
    input.email = (
      QAHiddenDriver.getPreferredEmail() ||
      input.email ||
      `${emailEnv}+primary${new Date().getTime()}@projecteagle.cc`
    ).replace('+NOW', '+' + new Date().getTime());
    input.phone = QAHiddenDriver.getPreferredPhone() || input.phone || '5555555555';
    if (input.coappFirst) {
      input.coappEmail = (
        QAHiddenDriver.getPreferredEmail('coapp') || `${emailEnv}+coapp${new Date().getTime()}@projecteagle.cc`
      ).replace('+coappNOW', '+coapp' + new Date().getTime());
    }

    input.product = mockModifiers.productType;

    const loanOperations = ['zipcode', 'customize', 'personal', 'credit', 'postCredit'];
    const cashOperations = ['cashZip', 'personal', 'postCredit', 'docGen'];

    let operations = input.product === 'cash' ? cashOperations : loanOperations;
    if (mockModifiers.includeDocGen) {
      operations = [...operations, 'docGen'];
    }

    operations.reduce((acc, fnc) => {
      return acc.then(
        () =>
          new Promise(async (res) => {
            try {
              await QAHiddenDriver.waitForElement(QAHiddenDriver.process[fnc]);
              console.log(`trying ${fnc}()`);
              await QAHiddenDriver.process[fnc].go(input);
            } catch (e) {
              console.log(`${QAHiddenDriver.process[fnc].id || QAHiddenDriver.process[fnc].name} never showed up`);
            }
            res();
          })
      );
    }, Promise.resolve());
  }

  static cssClick(el) {
    return new Promise((resolve, reject) =>
      setTimeout(() => {
        const elem = document.querySelectorAll(el);
        if (elem && elem[0]) {
          document.querySelectorAll(el)[0].click();
        } else {
          reject(`could not find ${el}`);
          throw new Error(`could not find ${el}`);
        }
        resolve();
      }, 750)
    ); //just enough to type a zip
  }

  static click(el) {
    return new Promise((resolve, reject) =>
      setTimeout(() => {
        const elem = document.getElementsByClassName(el);
        if (elem && elem[0]) {
          elem[0].click();
        } else {
          reject(`could not find ${el}`);
          throw new Error(`could not find ${el}`);
        }
        resolve();
      }, 750)
    ); //just enough to type a zip
  }

  static process = {
    cashZip: {
      go: async ({ zip } = {}) => {
        try {
          await QAHiddenDriver.cssClick('#cash-proposal');
          await QAHiddenDriver.sleep(500);
        } catch (e) {
          console.log('no quickcheck, skipping');
        }

        let state = {
          94929: 'CA',
          33309: 'FL',
          45238: 'OH',
          61754: 'IL',
          28217: 'NC',
          48060: 'MI',
          53703: 'WI',
          98843: 'WA',
          81212: 'CO',
        }[zip || '94929'];

        try {
          console.log(`trying set state select ${state}`);
          await QAHiddenDriver.setSelectValue(document.getElementById('cstate'), state);

          await QAHiddenDriver.click('action-primary');
          console.log(`set state select ${state}`);
        } catch (e) {
          console.log('e', e);
          console.log('clicking state button');
          QAHiddenDriver.getElementByClass(`qa-state-${state}-button`).click();
        }
      },
      id: 'cash-proposal',
    },
    zipcode: {
      go: async ({ zip, product } = {}) => {
        try {
          await QAHiddenDriver.cssClick('#proposal-calculator');
          await QAHiddenDriver.sleep(500);
        } catch (e) {
          console.log('no quickcheck, skipping');
        } // QC is dead

        let state = {
          94929: 'CA',
          33309: 'FL',
          45238: 'OH',
          61754: 'IL',
          28217: 'NC',
          48060: 'MI',
          53703: 'WI',
          98843: 'WA',
          81212: 'CO',
        }[zip || '94929'];

        try {
          if (product != null) {
            console.log(`trying set product select ${product}`);
            await QAHiddenDriver.setSelectValue(document.getElementById('product-type-select'), product);
          } else {
            console.log(`trying set default product`);
          }
          console.log(`trying set state select ${state}`);
          await QAHiddenDriver.setSelectValue(document.getElementById('cstate'), state);

          await QAHiddenDriver.click('action-primary');
          console.log(`set state select ${state}`);
        } catch (e) {
          console.log('e', e);
          console.log('clicking state button');
          QAHiddenDriver.getElementByClass(`qa-state-${state}-button`).click();
        }
      },
      id: 'proposal-calculator',
    },
    customize: {
      go: async () => {
        return await QAHiddenDriver.click('next-button');
      },
      class: 'project-cost',
    },

    personal: {
      go: async ({
        firstname,
        lastname,
        email,
        phone,
        address1,
        coappFirst,
        coappEmail,
        city,
        zip,
        lastNameOverrides,
      } = {}) => {
        QAHiddenDriver.setInputValue(document.getElementById('cfirstname'), firstname || 'User');
        QAHiddenDriver.setInputValue(document.getElementById('clastname'), (lastname || 'Test') + lastNameOverrides);
        QAHiddenDriver.setInputValue(document.getElementById('cemail'), email);
        QAHiddenDriver.setInputValue(document.getElementById('cphone1'), phone || '5555555555');
        QAHiddenDriver.setInputValue(document.getElementById('caddress1'), address1 || '555 Street');

        QAHiddenDriver.setInputValue(document.getElementById('ccity'), city || 'Dillon Beach');
        QAHiddenDriver.setInputValue(document.getElementById('czip'), zip || '94929');

        if (coappFirst) {
          await QAHiddenDriver.click('add-coapp-button');
          await QAHiddenDriver.sleep(500);
          QAHiddenDriver.setInputValue(document.getElementById('csecondaryfirstname'), coappFirst || 'Coapp');
          QAHiddenDriver.setInputValue(document.getElementById('csecondarylastname'), 'Test' + lastNameOverrides);
          QAHiddenDriver.setInputValue(document.getElementById('csecondaryemail'), coappEmail);
          QAHiddenDriver.setInputValue(document.getElementById('csecondaryphone'), '5555555555');
        }

        return await QAHiddenDriver.click('next-button');
      },
      id: 'caddress1',
    },

    credit: {
      go: async ({
        ssn,
        dob,
        income,
        email,
        coappDob,
        coappSsn,
        coappEmail,
        cowner,
        cresident,
        csecondaryowner,
        csecondaryresident,
      } = {}) => {
        await QAHiddenDriver.click('hand-over');
        await QAHiddenDriver.click('hand-over'); //twice

        setTimeout(async () => {
          QAHiddenDriver.setInputValue(document.getElementById('cdob'), dob || '01/01/1991');
          QAHiddenDriver.setInputValue(document.getElementById('cssn'), ssn || '999999991');
          QAHiddenDriver.setInputValue(document.getElementById('cgrossannualincome'), income || '75000');
          try {
            document.getElementById(cowner === 'false' ? 'cowner-false' : 'cowner-true').click();
            document.getElementById(cresident === 'false' ? 'cresident-false' : 'cresident-true').click();
            document.getElementById('disclosure-terms-accept').click();
          } catch (e) {}
          QAHiddenDriver.setInputValue(document.getElementById('applicantSignature'), email || 'user.test@example.com');

          if (coappDob || coappSsn || coappEmail) {
            await QAHiddenDriver.click('continue-to-coapp');
            await QAHiddenDriver.sleep(500);

            QAHiddenDriver.setInputValue(document.getElementById('csecondarydob'), coappDob || '01/01/1991');
            QAHiddenDriver.setInputValue(document.getElementById('csecondaryssn'), coappSsn || '999999999');
            QAHiddenDriver.setInputValue(document.getElementById('csecondarygrossannualincome'), '75000');
            try {
              document
                .getElementById(csecondaryowner === 'false' ? 'csecondaryowner-false' : 'csecondaryowner-true')
                .click();
              document
                .getElementById(csecondaryresident === 'false' ? 'csecondaryresident-false' : 'csecondaryresident-true')
                .click();
              document.getElementById('disclosure-terms-accept-coapp').click();
            } catch (e) {}
            QAHiddenDriver.setInputValue(
              document.getElementById('coapplicantSignature'),
              coappEmail || 'user.test@example.com'
            );
          }
          setTimeout(() => {
            QAHiddenDriver.click('apply-for-credit');
          }, 500);
        }, 500);
      },
      class: 'hand-over',
    },
    postCredit: {
      go: async ({ product }) => {
        if (product === 'cash') {
          await QAHiddenDriver.sleep(5 * 1000); // interstitial clears on its own, eventually
        } else {
          await QAHiddenDriver.waitForElement({ class: 'show-results-link' });
          await QAHiddenDriver.sleep(3 * 1000); // give stuff time to propagate... apparently
          await QAHiddenDriver.click('show-results-link');
          await QAHiddenDriver.sleep(1000);
          await QAHiddenDriver.setInputValue(document.getElementById('projectCost'), '25000');
          await QAHiddenDriver.sleep(500);
          await QAHiddenDriver.click(document.getElementsByClassName('container'));
        }
      },
      class: 'show-results-link',
    },
    postCreditRateCardChange: {
      go: async ({ rateCard }) => {
        await QAHiddenDriver.cssClick(rateCard || '.qa-Choice-12-2\\.99 input');
        await QAHiddenDriver.sleep(5 * 1000);
      },
      class: 'eligibility-page',
    },
    docGen: {
      go: async () => {
        await QAHiddenDriver.click('action-contents');
      },
      class: 'eligibility-page',
    },
  };
}

window.QAHiddenDriver = QAHiddenDriver;

export default QAHiddenDriver;
